<template>
  <draggable :list="stopList" tag="div" @change="handleStopOrderChange" :disabled="isUpdateOrder">
    <div v-for="(item, index) in stopList" :key="index" class="mt-2">
      <BusScheduleItem
        :item="item"
        @on-add-student="onAddStudent"
        @on-remove-student="onRemoveStudent"
        @on-update-bus-stop="onUpdateBusStop"
        @on-delete-bus-stop="onDeleteBusStop"
        @on-edit-student-default-absent="onEditStudentDefaultAbsent"
      />
    </div>
  </draggable>
</template>
<script>
import draggable from 'vuedraggable'
import BusScheduleItem from './BusScheduleItem.vue'
import { mapActions } from 'vuex'
export default {
  components: {
    draggable,
    BusScheduleItem,
  },
  props: {
    busStopList: Array,
  },
  data() {
    return {
      originOrders: [],
      stopList: [],
      isUpdateOrder: false,
    }
  },
  methods: {
    ...mapActions('busDetail', ['updateBusStopOrder']),
    handleBusStopList(busStopList = []) {
      this.stopList = busStopList
        .map((item, index) => {
          if (item.index > -1) return item
          return { ...item, index }
        })
        .sort((a, b) => a.index - b.index)
      this.originOrders = busStopList.map((item, index) => ({ id: item.id, index }))
    },
    async handleStopOrderChange() {
      try {
        this.isUpdateOrder = true
        const orders = this.stopList.map((item, index) => ({ id: item.id, index }))
        await this.updateBusStopOrder({ orders })
        this.$alert.updateSuccess('thứ tự điểm dừng')
        this.isUpdateOrder = false
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.isUpdateOrder = false
      }
    },
    // retain-event from bus-schedule-item
    onAddStudent(item) {
      this.$emit('on-add-student', item)
    },
    onRemoveStudent(item) {
      this.$emit('on-remove-student', item)
    },
    onUpdateBusStop(item) {
      this.$emit('on-update-bus-stop', item)
    },
    onDeleteBusStop(item) {
      this.$emit('on-delete-bus-stop', item)
    },
    onEditStudentDefaultAbsent(item) {
      this.$emit('on-edit-student-default-absent', item)
    },
  },
  watch: {
    busStopList: {
      handler(val) {
        if (Array.isArray(val) && val.length) {
          this.handleBusStopList(val)
        }
      },
      immediate: true,
      deep: true,
    },
  },
}
</script>
